import { render, staticRenderFns } from "./choosePersonOne.vue?vue&type=template&id=7050827f&scoped=true"
import script from "./choosePersonOne.vue?vue&type=script&lang=js"
export * from "./choosePersonOne.vue?vue&type=script&lang=js"
import style0 from "./choosePersonOne.vue?vue&type=style&index=0&id=7050827f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7050827f",
  null
  
)

export default component.exports